import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { Roster } from "@/types/classroom";
import { ReducerFn } from "@lib/utils/redux/reducers/types";
import { setRoster } from '@/redux/actions/roster-actions';
import { RosterUpdatePayload, updateRoster } from '../actions/firebase-actions';

export type RosterState = Roster;

const INITIAL_STATE: RosterState = {};

type RosterReducer<P> = ReducerFn<RosterState, P>;

const handleSetRoster: RosterReducer<Roster> = (state, roster) => ({ ...roster });

const handleUpdateRoster: RosterReducer<RosterUpdatePayload> = (
    state, { roster, isLTI }
) => {
    if (isLTI) {
        return state;
    }
    // only use Firebase's `teacherClassrooms` doc as a roster source
    // in non-LTI mode.
    return { ...roster };
};

export const rosterReducers = reducerWithInitialState(INITIAL_STATE)
  .case(setRoster, handleSetRoster)
  .case(updateRoster, handleUpdateRoster)
  .build();
